import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/financial/paymentRequestReportActions'
import * as api from '../../../api/reports/financial/paymentRequestReport'

function* paymentRequestReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* paymentRequestReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* paymentRequestReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchPaymentRequestReportGetJobList() {
  yield takeLatest(
    constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.ACTION,
    paymentRequestReportGetJobList
  )
}

function* watchPaymentRequestReportGetOrganizationList() {
  yield takeLatest(
    constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.ACTION,
    paymentRequestReportGetOrganizationList
  )
}

function* watchPaymentRequestReportGetFullReport() {
  yield takeLatest(
    constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.ACTION,
    paymentRequestReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchPaymentRequestReportGetJobList),
    fork(watchPaymentRequestReportGetOrganizationList),
    fork(watchPaymentRequestReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/financial/paymentRequestReportSaga.js